import { apiHandlerEndpoint, requestOpta } from "./apiHandlerClient";

// SERVIDOR
// Cada función devuelve el cuerpo de Opta tal cual, o `null` si falló.

/** Temporadas de una competición. `withStages` agrega las etapas (para detectar fase regular). */
export const fetchCompetitionTournaments = ({ competitionId, withStages = false } = {}) =>
    requestOpta(apiHandlerEndpoint.competitionTournaments(competitionId), {
        stages: withStages ? "yes" : undefined,
        authorized: "yes",
    });

/** Competiciones y temporadas que juega un equipo. */
export const fetchTeamTournaments = ({ teamId } = {}) =>
    requestOpta(apiHandlerEndpoint.teamTournaments(teamId));

/** Ficha del equipo (`contestant`) con plantel. */
export const fetchTeam = ({ teamId } = {}) => requestOpta(apiHandlerEndpoint.team(teamId));

/** Partidos de una temporada, con filtros opcionales por equipo y jornada. */
export const fetchMatches = ({ calendarId, teamId, status, week, pageSize } = {}) =>
    requestOpta(apiHandlerEndpoint.fixture(calendarId), {
        status,
        team: teamId,
        week,
        pgSz: pageSize,
    });

/**
 * Detalle y estadísticas de un partido. Devuelve el partido, no una lista.
 */
export const fetchMatchStats = ({ matchId } = {}) =>
    requestOpta(apiHandlerEndpoint.matchStats(matchId));

/** Minuto a minuto de un partido, en español. */
export const fetchCommentary = ({ matchId } = {}) =>
    requestOpta(apiHandlerEndpoint.commentary(matchId));
